<div [class.closed]="!isOpen" class="widget-wrapper" data-cy="widget-panel">
	<div class="widget-content">
		<div class="widget-column">
			<div class="custom-card bg-white">
				<app-graph-risk></app-graph-risk>
			</div>
		</div>
	</div>
</div>
